import React, { ReactNode } from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { config } from '../index';

export interface PageWrapperProps {
  /* PageWrapper background color */
  backgroundColor?: string;
  /* PageWrapper padding */
  padding?: string;
  /* PageWrapper children components */
  children?: ReactNode;
  /* PageWrapper onScroll callBack */
  onScroll?: (res?: any) => void;
}

const StyledPageWrapper = styled.div<PageWrapperProps>`
  display: flex;
  height: 100vh;
  flex-direction: column;
  overflow: hidden;
  overflow-y: scroll;

  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
`;

export const PageWrapper: React.FC<PageWrapperProps> = ({
  backgroundColor = config.transparent,
  padding = 'unset',
  children,
  // --------------------------------------------------------------------------------
  onScroll,
  // additional props
  ...props
}) => {
  const onScrollHandler = (event: React.UIEvent<HTMLDivElement>) => {
    // --------------------------------------------------------------------------------
    // 📌  Page onScroll callback events
    // --------------------------------------------------------------------------------
    const scrollTop = event.currentTarget.scrollTop;
    const scrollHeight = event.currentTarget.scrollHeight;
    const clientHeight = event.currentTarget.clientHeight;
    // console.log('🐞 ', scrollTop + clientHeight, scrollHeight);

    // on top reached callBack
    if (scrollTop === 0) {
      const msg = 'top';
      onScroll?.(msg);
    }

    // detect when bottom reached
    if (scrollTop + clientHeight >= scrollHeight) {
      const msg = 'bottom';
      onScroll?.(msg);
    }

    onScroll?.(scrollTop);
  };

  return (
    <StyledPageWrapper
      backgroundColor={backgroundColor}
      padding={padding}
      onScroll={onScrollHandler}
      // any additional props that override the defaults
      {...props}
    >
      {children}
    </StyledPageWrapper>
  );
};
